import { render, staticRenderFns } from "./CommunicationViewGlobal.vue?vue&type=template&id=2c0c47fb"
import script from "./CommunicationViewGlobal.vue?vue&type=script&lang=js"
export * from "./CommunicationViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports